import { createAction } from '@reduxjs/toolkit';

import { getFailurePayloadCreator, getPayloadCreator } from '../core/actionHelpers';
import type { QcsSyncResourcesPayload } from '../core/resourceStoreTypes';
import type {
  InvestmentQuotesV2Meta,
  InvestmentQuotesV2Request,
  InvestmentQuoteTypeV2,
} from './investmentQuotesV2Types';

export const getInvestmentQuotesV2 = createAction(
  'GET_INVESTMENT_QUOTES_V2',
  (payload?: InvestmentQuotesV2Request, meta?: InvestmentQuotesV2Meta) => ({ payload, meta }),
);
export const getInvestmentQuotesV2Success = createAction(
  'GET_INVESTMENT_QUOTES_V2_SUCCESS',
  getPayloadCreator<QcsSyncResourcesPayload<InvestmentQuoteTypeV2>>(),
);
export const getInvestmentQuotesV2Failure = createAction(
  'GET_INVESTMENT_QUOTES_V2_FAILURE',
  getFailurePayloadCreator(),
);
